
export class PublishVoiceHistoryRequestModel {
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // 受付番号
  public receiptNum: string = <string>'';

  // 会員生協リスト
  public coopInfoList: any = new Array<any>();
}
